import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Breadcrumbs, Typography, Grid } from '@mui/material';
import * as sitesActions from '../actions/sites';
import PushTable from '../components/PushTable';

const PushView = () => {
  const dispatch = useDispatch();
  const site = useSelector((state) => state.app.site);
  const sitePush = useSelector((state) => state.entities.sites.push);
  const sitePushList = sitePush.bySiteId[site.id] || [];

  const data = sitePushList.map((row) => ({
    ...row,
    number_of_recipients: row.users_ids.length,
  }));

  useEffect(() => {
    dispatch(sitesActions.fetchSitePushIfNeeded(site.id));
  }, []);

  return (
    <>
      <Breadcrumbs aria-label="Breadcrumbs">
        <Typography color="textPrimary">Sent Push</Typography>
      </Breadcrumbs>

      <Grid container>
        <Grid item xs={12}>
          <PushTable tableId="#push-table" isLoading={sitePush.inflight} pushes={data} />
        </Grid>
      </Grid>
    </>
  );
};

export default PushView;
